export const API = `${process.env.REACT_APP_BACKEND_URL || ""}/api`;

export const COUNTIES = {
  anderson: { name: "Anderson", blurb: "Cann Realty's home turf — farmland, lake tracts, and in-town homes." },
  pickens: { name: "Pickens", blurb: "Foothills acreage and mountain-view parcels near Table Rock." },
  greenville: { name: "Greenville", blurb: "Development land and homes in the Upstate's fastest-growing market." },
  oconee: { name: "Oconee", blurb: "Lake Keowee frontage, timberland, and hunting retreats." },
  abbeville: { name: "Abbeville", blurb: "Historic farm country with large working tracts." },
  laurens: { name: "Laurens", blurb: "Rolling pasture and investment acreage along the I-385 corridor." },
  hart: { name: "Hart", blurb: "Lake Hartwell shoreline and north Georgia farmland." },
  elbert: { name: "Elbert", blurb: "Georgia timber and cattle country minutes from the SC line." },
  franklin: { name: "Franklin", blurb: "North Carolina mountain land within easy reach of the Upstate." },
};

export const PROPERTY_TYPES = {
  land: { label: "Raw Land", singular: "land" },
  farm: { label: "Farm & Acreage", singular: "farm or acreage" },
  residential: { label: "Home", singular: "home" },
  commercial: { label: "Commercial", singular: "commercial property" },
};

export const TIMELINE_OPTIONS = [
  { value: "immediate", label: "As soon as possible", hint: "Ready to list now" },
  { value: "1-3_months", label: "1–3 months", hint: "Getting prepared" },
  { value: "3-6_months", label: "3–6 months", hint: "Planning ahead" },
  { value: "curious", label: "Just curious", hint: "Want to know the value" },
];

export const COUNTY_OPTIONS = Object.entries(COUNTIES).map(([key, c]) => ({ value: key, label: `${c.name} County` }));

export const PROPERTY_TYPE_OPTIONS = Object.entries(PROPERTY_TYPES).map(([key, t]) => ({ value: key, label: t.label }));

const TYPE_HEADLINES = {
  land: "We Sell {place} Land Faster. For More.",
  farm: "Your {place} Farm Deserves a Specialist's Price.",
  residential: "Sell Your {place} Home With a Local Who Delivers.",
  commercial: "{place} Commercial Property, Positioned to Sell.",
};

export function getPersonalization(searchParams) {
  const countyKey = (searchParams.get("county") || "").toLowerCase();
  const typeKey = (searchParams.get("type") || "").toLowerCase();
  const source = (searchParams.get("source") || searchParams.get("utm_source") || "direct").toLowerCase();
  const county = COUNTIES[countyKey] || null;
  const type = PROPERTY_TYPES[typeKey] || null;
  const place = county ? `${county.name} County` : "SC Upstate";

  const headline = type
    ? TYPE_HEADLINES[typeKey].replace("{place}", place)
    : county
      ? `Your ${county.name} County Property Is Worth More Than You Think.`
      : "Your South Carolina Property Is Worth More Than You Think.";

  const subheadline = type
    ? `Jody Cann has spent 24 years pricing and selling ${type.singular} across the Upstate. Get a free, no-pressure valuation.`
    : "24 years selling land, farms, and homes across the South Carolina Upstate. Get a free, no-pressure valuation.";

  const badge = county
    ? `Now touring ${county.name} County properties`
    : source !== "direct"
      ? `Exclusive offer for ${source} visitors`
      : "Free property valuation";

  return {
    countyKey: county ? countyKey : "",
    countyName: county ? county.name : "",
    typeKey: type ? typeKey : "",
    source,
    utm_medium: searchParams.get("utm_medium") || "",
    utm_campaign: searchParams.get("utm_campaign") || "",
    headline,
    subheadline,
    badge,
  };
}

export const LISTINGS = [
  {
    id: 1, kind: "land", status: "For Sale", price: 1550000,
    address: "3961 Forrester Road", city: "Greer, SC 29651",
    detail: "Premium acreage tract",
    img: "https://dlajgvw9htjpb.cloudfront.net/cms/35b9799b-9bbc-4363-9a9f-97b04116a6f5/20304289/-5604072236000607544.jpg",
  },
  {
    id: 2, kind: "home", status: "For Sale", price: 1300000,
    address: "225 Meadow Brook Lane", city: "Pickens, SC 29671",
    detail: "4 Beds · 4 Baths",
    img: "https://dlajgvw9htjpb.cloudfront.net/cms/35b9799b-9bbc-4363-9a9f-97b04116a6f5/20302796/8225520131457660102.jpg",
  },
  {
    id: 3, kind: "home", status: "For Sale", price: 1150000,
    address: "284 River Road", city: "Westminster, SC 29693",
    detail: "5 Beds · 4 Baths · 3,600 Sq.Ft.",
    img: "https://dlajgvw9htjpb.cloudfront.net/cms/35b9799b-9bbc-4363-9a9f-97b04116a6f5/20293691/8174628707221674237.jpg",
  },
  {
    id: 4, kind: "land", status: "For Sale", price: 850000,
    address: "1425 Amity Road", city: "Anderson, SC 29621",
    detail: "Anderson County acreage",
    img: "https://dlajgvw9htjpb.cloudfront.net/cms/35b9799b-9bbc-4363-9a9f-97b04116a6f5/20269060/8019109459225614642.jpg",
  },
  {
    id: 5, kind: "land", status: "For Sale", price: 658000,
    address: "900 Simpson Road", city: "Belton, SC 29627",
    detail: "Pasture & timber mix",
    img: "https://dlajgvw9htjpb.cloudfront.net/cms/35b9799b-9bbc-4363-9a9f-97b04116a6f5/20300050/2525594921952747535.jpg",
  },
  {
    id: 6, kind: "land", status: "For Sale", price: 390000,
    address: "401 Coleman Road", city: "Clinton, SC 29325",
    detail: "Recreational tract",
    img: "https://dlajgvw9htjpb.cloudfront.net/cms/35b9799b-9bbc-4363-9a9f-97b04116a6f5/20303079/1568241443360480767.jpg",
  },
];

export const TESTIMONIALS = [
  {
    quote: "Jody Cann sold my house in one month after another realtor didn't. He researched the market, advised me of the issue, and advertised it across the whole SC Upstate — not just Anderson.",
    name: "Jim Barnes", tag: "Home Seller · Anderson, SC",
  },
  {
    quote: "My property sat with another agent for years at a much lower price. Jody listed it and within 24 hours he had buyers at a much higher price. If you're having a tough time selling — he's your man.",
    name: "Shriley B.", tag: "Land Seller · Upstate SC",
  },
  {
    quote: "Living out of state, I needed someone I could trust. Jody was a great listener and an excellent communicator. The property sold quickly and I was never pressured to lower the price for a quick sale.",
    name: "Donna R.", tag: "Out-of-State Seller",
  },
  {
    quote: "When we lost a cash contract, Jody simply doubled his efforts and we were back under contract within a week — at a higher price. You will not find a broker who works harder for his clients.",
    name: "William G.", tag: "Land Seller · Anderson County",
  },
  {
    quote: "Another agent had our land for years with only one offer that fell through. Jody presented a very good offer in a timely manner and followed through every detail, including a tricky estate issue.",
    name: "Juanita W.", tag: "Estate Land Sale · Anderson, SC",
  },
];

export const STATS = [
  { id: "trust-stat-years", value: "24+", label: "Years in SC real estate" },
  { id: "trust-stat-counties", value: "9", label: "Upstate counties covered" },
  { id: "trust-stat-volume", value: "$150M+", label: "Career volume represented" },
  { id: "trust-stat-satisfaction", value: "100%", label: "Local, hands-on focus" },
];

const CDN = "https://media-production.lp-cdn.com/cdn-cgi/image/format=auto,quality=85";
const CDN_W = (w) => `https://media-production.lp-cdn.com/cdn-cgi/image/format=auto,quality=85,fit=scale-down,width=${w}`;

export const IMAGES = {
  logoWhite: `${CDN_W(1600)}/https://media-production.lp-cdn.com/media/fe4629b2-73bf-4266-8c0e-ae14ef33a00b`,
  logoPlaque: `${CDN}/https://media-production.lp-cdn.com/media/50cc6cf5-6e1e-407c-b3f2-2d42bb48ad19`,
  heroVideoWebm: "https://res.cloudinary.com/luxuryp/videos/f_webm,vc_vp9,w_1920,c_limit/nvpf4wbb2kohn7qtibgs/hov-dji-0766.webm",
  heroVideoMp4: "https://res.cloudinary.com/luxuryp/videos/f_mp4,vc_h264,w_1920,c_limit/nvpf4wbb2kohn7qtibgs/hov-dji-0766.mp4",
  heroPoster: "https://res.cloudinary.com/luxuryp/videos/f_auto,q_auto/so_0,eo_0/nvpf4wbb2kohn7qtibgs/hov-dji-0766.jpg",
  jody: `${CDN_W(1280)}/https://media-production.lp-cdn.com/media/3c4698e8-08fd-485e-976f-661f1189160a`,
  sell: `${CDN}/https://media-production.lp-cdn.com/media/4d1bc7ee-a1bd-45f4-b3d6-6fed23d57276`,
  buy: `${CDN}/https://media-production.lp-cdn.com/media/20e0ee38-806d-42b5-8cd3-e714bbe62b9f`,
  contact: `${CDN_W(1280)}/https://media-production.lp-cdn.com/media/64e1de8f-a4c1-4c7b-8f45-6cc7201cac42`,
};

export const COUNTY_IMAGES = {
  anderson: `${CDN_W(800)}/https://media-production.lp-cdn.com/media/l7xgsevdpjpl1coirdd0`,
  pickens: `${CDN_W(800)}/https://media-production.lp-cdn.com/media/742755b5-2a31-41bd-b55e-8900e2bdaba0`,
  greenville: `${CDN_W(800)}/https://media-production.lp-cdn.com/media/yntks2cidqklmngl6r3h`,
  oconee: `${CDN_W(800)}/https://media-production.lp-cdn.com/media/5bdccf5d-7093-49d3-a1bc-e62bea0bb086`,
  abbeville: `${CDN_W(800)}/https://media-production.lp-cdn.com/media/i0q3adlfif7syvnk9fc4`,
  laurens: `${CDN_W(800)}/https://media-production.lp-cdn.com/media/e9076e18-a3c8-4504-9981-82652de89bd5`,
  hart: `${CDN_W(800)}/https://media-production.lp-cdn.com/media/075c0ea0-2cfc-4d70-8cd5-1d3023270f26`,
  elbert: `${CDN_W(800)}/https://media-production.lp-cdn.com/media/1cecf84d-c0e2-4557-8d65-4dc00aa52802`,
  franklin: `${CDN_W(800)}/https://media-production.lp-cdn.com/media/dea983bc-95a7-45ff-b07c-6caa21ef60fa`,
};
